import React from 'react';
import { Invoices } from './Invoices';

/**
 * Admin-only page: bulk-email consolidated monthly statements to residents.
 * Renders the shared Invoices component in `statements` mode.
 * Individual payment receipts live on Payment Approvals and User Management
 * (purple receipt icon).
 */
const Statements = () => <Invoices view="statements" />;
export default Statements;
export { Statements };
